export { default } from "./GeniusAssignModal";
